//
// Logo
//
export var ODGNBLogoType;
(function (ODGNBLogoType) {
    ODGNBLogoType["Text"] = "Text";
    // OneImage = 'OneImage',
    // ResponsiveImage = 'ResponsiveImage',
})(ODGNBLogoType || (ODGNBLogoType = {}));
export var ODAppBarThemeType;
(function (ODAppBarThemeType) {
    ODAppBarThemeType["Default"] = "default";
    ODAppBarThemeType["CoreUILike"] = "cui";
})(ODAppBarThemeType || (ODAppBarThemeType = {}));
//
// GNB Footer
//
export var ODFooterType;
(function (ODFooterType) {
    ODFooterType["CollapsingSectionFooter"] = "CollapsingSectionFooter";
})(ODFooterType || (ODFooterType = {}));
//# sourceMappingURL=gnbInterfaces.js.map